<template>
	<div class="about">
		<img style="width: 100%;" class="wow fadeIn" src="../../assets/mobile/contectBg.jpg" />
		<div class="mainArea contentinfo">		
			<!-- <div id="container" class="map-container"></div> -->
			<img src="../../assets/mobile/map.png" style="width: 100%;"/>
			<div class="abBox wow fadeIn">
				<div class="title">公司信息</div>
				<dl class="a">
					<img src="../../assets/phone.png"/>
					<dt>联系方式</dt>
					<dd>021-59199956</dd>
				</dl>
				<dl>
					<img src="../../assets/local_s.png"/>
					<dt>办公地点</dt>
					<dd>上海市徐汇区漕溪北路595号A座8013室</dd>
				</dl>
				<dl>
					<dt>商务中心</dt>
					<dd>上海市青浦区华隆路1777号E通世界华新园H座8楼</dd>
				</dl>
			</div>
		</div>
	</div>
</template>
<script>
	import AMapLoader from '@amap/amap-jsapi-loader';
	window._AMapSecurityConfig = {
		securityJsCode: '	b3601ce8b15ead7329ec38d6e4c37bc2'
	};
	import { WOW } from 'wowjs'
	export default {
		name: 'Home',
		data() {
			return {
				map: null, // 地图实例 (也可在created外直接定义 let map = null; 避免响应式):cite[3]
				marker: null, // 标记点
				geocoder: null, // 地理编码器
				AutoComplete: null, // 搜索提示插件
				keywords: '', // 搜索关键词
				lng: 121.437985, // 经度
				lat: 31.186459, // 纬度
				address: '' // 地址
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(!isM){
				this.$router.push({ path: '/pc/contect'});
			}
		},
		mounted() {
			this.$nextTick(() => {
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
				//this.initMap();
			})
		},
		methods: {
			initMap() {
				AMapLoader.load({
					key: 'b3601ce8b15ead7329ec38d6e4c37bc2',
					version: '2.0', // SDK 版本
					plugins: [ // 按需加载插件:cite[1]:cite[3]
						'AMap.Geocoder', // 地理编码（地址解析）
						'AMap.AutoComplete', // 输入提示
						'AMap.ToolBar', // 缩放控制
						'AMap.HawkEye' // 鹰眼
					]
				}).then((AMap) => {
					// 创建地图实例
					this.map = new AMap.Map('container', {
						mapStyle:'amap://styles/whitesmoke',
						viewMode: '2D', // 使用3D视图
						zoom: 18, // 初始缩放级别
						center: [this.lng, this.lat], // 初始中心点
					});

					// 4. 添加控件
					//this.map.addControl(new AMap.ToolBar());
					//this.map.addControl(new AMap.HawkEye());

					// 初始化插件
					this.geocoder = new AMap.Geocoder({
						city: '全国', // 城市限定，默认“全国”
						radius: 1000 // 搜索半径
					});
					this.AutoComplete = new AMap.AutoComplete({
						city: "全国"
					});

					// 5. 添加标记点
					this.setMarker(this.lng, this.lat);

					// 6. 绑定地图点击事件
					this.map.on('click', (e) => {
						this.lng = e.lnglat.lng;
						this.lat = e.lnglat.lat;
						this.setMarker(this.lng, this.lat);
						this.getAddress(this.lng, this.lat); // 反查地址
					});

				}).catch(e => {
					console.error('地图加载失败', e);
				})
			},

			// 设置标记点
			setMarker(lng, lat) {
				if (this.marker) {
					this.map.remove(this.marker); // 清除旧标记
				}
				const markerContent = `<div class="custom-content-marker">
				<img src="https://pg-txpc.oss-cn-shanghai.aliyuncs.com/icon/local_b.png">
				</div>`
				this.marker = new AMap.Marker({
					position: [lng, lat],
					map: this.map,
					content:markerContent
				});
				this.map.setCenter([lng, lat]); // 中心点移动到标记位置
			},

			// 根据经纬度获取地址（逆地理编码）
			getAddress(lng, lat) {
				this.geocoder.getAddress([lng, lat], (status, result) => {
					if (status === 'complete' && result.regeocode) {
						this.address = result.regeocode.formattedAddress;
					} else {
						this.address = '获取地址失败';
					}
				});
			},		
		},
		beforeDestroy() {
			// 销毁地图实例:cite[2]
			if (this.map) {
				this.map.destroy();
			}
		}

	}
</script>
<style lang="less" scoped>
	.about{
		background: #000;
	}
	.contentinfo{
		position: relative;
		border-radius: 5px;
		margin-top: -50px;
		padding-bottom: 50px;
		z-index: 2;
	}
	.abBox{
		background: #FF5500;
		text-align: left;
		border-radius: 2px;
		color: #fff;
		padding: 40px;
		font-size: 14px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.title{
			font-size: 24px;
			margin-bottom: 20px;
		}
		.a{
			margin-bottom: 20px;
			padding-bottom: 20px;
			border-bottom: 0.5px solid rgba(255, 255, 255, 0.5);
			
			
		}
		dt{
			font-weight: bold;
			margin-bottom: 5px;
			margin-top: 20px;
		}
		dd{
			font-weight: 400;
			line-height: 20px;
			font-size: 12px;
			opacity: 0.8;
		}
	}
	#container{
		width: 100%;
		height: 200px;
		border-radius: 2px;
	}
</style>